const decodeStoredJson = (value: unknown): unknown => {
    let decoded = value;

    while (typeof decoded === 'string') {
        try {
            decoded = JSON.parse(decoded);
        } catch {
            break;
        }
    }

    return decoded;
};

export const normalizeEmailDraft = <T extends Record<string, unknown>>(draft: T): T => {
    let normalized = draft;

    // Existing draft updates could encode cast JSON attributes a second time.
    [
        'cc',
        'bcc',
        'subject_translation',
        'body_translation',
        'design_translation',
        'design',
    ].forEach((field) => {
        const decoded = decodeStoredJson(draft[field]);
        const isRecipientList = field === 'cc' || field === 'bcc';
        const isExpectedShape = isRecipientList
            ? Array.isArray(decoded)
            : decoded !== null &&
              typeof decoded === 'object' &&
              (field === 'design' || !Array.isArray(decoded));

        if ((isExpectedShape && decoded !== draft[field]) || (isRecipientList && decoded == null)) {
            normalized = { ...normalized, [field]: decoded ?? [] };
        }
    });

    return normalized;
};
